// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-user .search-filter .search-header-profile{padding:18px 0 17px !important}
`, "",{"version":3,"sources":["webpack://./src/app/pages/AdminUser/style.scss"],"names":[],"mappings":"AAAA,kDAGY,8BAA+B","sourcesContent":[".admin-user{\n    .search-filter {\n        .search-header-profile {\n            padding: 18px 0 17px !important;\n        }\n      }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
